import { Button, Icon, IconButton, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import * as S from './style';

export default function ProductWidgetHeader({
  onClose,
  productCount,
  onSaveAsCollection,
  showSaveAsCollectionButton = true
}) {
  const { t } = useTranslation();
  return (
    <S.WidgetHeader>
      <S.WidgetHeaderTitle>
        <S.WidgetHeaderTitleHead>
          <Icon name="gift-box" />
          <Typography variant="subtitle4Bold" style={{ marginLeft: '4px' }}>
            {t('giftCollection')}
          </Typography>
        </S.WidgetHeaderTitleHead>
        <IconButton onClick={onClose} color="secondary" variant="link">
          <Icon name="close-right" />
        </IconButton>
      </S.WidgetHeaderTitle>
      <Typography variant="body2SemiBold" color="fg" emphasis="weaker">
        <Trans i18nKey={'cartHeaderDesc'} components={{ b: <b /> }} />
      </Typography>
      {productCount > 0 && showSaveAsCollectionButton && (
        <Button
          color="primary"
          variant="link"
          onClick={onSaveAsCollection}
          startIcon={<Icon name="shopping-bag" />}
          style={{ textTransform: 'math-auto' }}
        >
          {t('saveItemsNewCollection')}
        </Button>
      )}
    </S.WidgetHeader>
  );
}
